// removed by extract-text-webpack-plugin
module.exports = {"container":"email-input-element__container__a64ey"};


//////////////////
// WEBPACK FOOTER
// ./src/components/forms/email-input-element.scss
// module id = 1227
// module chunks = 1